import { transformUrlToLanguage } from "./market.helper";
import {ILanguage} from "@montana/models/generated/cms.interface";

export const extractCTALink = (content?: string) => {
    if (!content) {
        return null;
    }

    const anchorTagsRegex = /<a[\s]+([^>]+)>((?:.(?!<\/a>))*.)<\/a>/g;
    const anchorTags = content.match(anchorTagsRegex);

    let ctaLink: string | null = null;

    anchorTags?.forEach(a => {
        if (a.includes('data-epi')) {
            const href = a.match(/<a[^>]+href="(.*?)"(?:.*?)[^>]>/);
            ctaLink = href ? href[1] : null;
        }
    });

    return ctaLink;
}

export const formatRichTextLinks = (content: string, language: string, languages: ILanguage[] | undefined) => {
    const linkHref = new RegExp(/href="([^'"]+)/g);

    let href: RegExpExecArray | null;

    // Replace all relative urls' language with the market id
    while ((href = linkHref.exec(content)) !== null) {
        const hrefString = href[1];
        if (hrefString?.startsWith('/')) {
            content = content.replace(hrefString, transformUrlToLanguage(languages, hrefString, language));
        }
    }

    return content;
}
